type IdentityValidationFieldError = {
  fieldName: 'personalIdentificationNumber' | 'personalPhoneNumber';
  messageKey: 'COMPANY_RELATION' | 'MOBILE_VERIFICATION_NOT_OWNER';
};

export const isValidationServerError = (status?: number, description?: string): boolean =>
  (status !== undefined && status >= 500 && status < 600) ||
  description === 'Internal Server Error';

export const getIdentityValidationFieldError = (
  code?: string
): IdentityValidationFieldError | undefined => {
  switch (code) {
    case 'COMPANY_RELATION':
      return { fieldName: 'personalIdentificationNumber', messageKey: code };
    case 'MOBILE_VERIFICATION_NOT_OWNER':
      return { fieldName: 'personalPhoneNumber', messageKey: code };
    default:
      return undefined;
  }
};
